import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Brand from './../img/logo.webp'
import Favicon from './../img/favicon.png'
import AddLeadPopup from './../components/AddLeadPopup';

const Header = () => {

    const [state, setState] = useState(1);
    const [nav, setNav] = useState("fa fa-bars");
    const [toggleLeadPopup, setToggleLeadPopup] = useState(0);


    const [userDetails, setUserDetails] = useState([]);
    const [designation, setDesignation] = useState();

    const location = useLocation();

    const navigate = useNavigate();

    // console.log(location.pathname);


    useEffect(() => {
        if (localStorage.getItem("user")) {
            const userData = JSON.parse(localStorage.getItem("user"));
            setUserDetails(userData);
            setDesignation(userData.designation);
            // console.log(userData);
        }
        else {
            navigate("/login");
        }

        // localStorage.clear();
    }, []);

    const drawer = (status) => {
        document.querySelector('.sidebar').style.left = status === 1 ? 'calc(100% - 250px)' : 'calc(100% - 55px)';
        // document.querySelector('.header-right i.fa-bars').style.display = status === 1? 'none' : 'block';
        // document.querySelector('.header-right i.fa-power-off').style.display = status === 1? 'block' : 'none';
        if (state === 1) {
            setState(0);
            setNav("fa fa-times");
        }
        else if (state === 0) {
            setState(1);
            setNav("fa fa-bars");
        }
    }

    const logout = () => {
        localStorage.clear();
        navigate("/login");
    }


    const closeLeadPopup = () => {
        setToggleLeadPopup(0);
    }
    const reload = () => {

    }

    return (
        <>

            {toggleLeadPopup === 1 ?
                <AddLeadPopup reload={reload} close={closeLeadPopup} />
                : <></>
            }
            <div className='header'>
                <h2 className='crm'> <img className="favicon" src={Favicon} /> CRM </h2>

                <div className='header-right'>
                    <h2 className='designation'> {userDetails.name} </h2>
                    <i className='fa fa-power-off visible-hide logout' onClick={() => logout()}></i>
                    <i className={nav + ' hide-visible'} onClick={() => { drawer(state) }}></i>
                </div>
            </div>
            <div className='sidebar'>
                <img className='brand visible-hide' src={Brand} alt="swarnbhoomii-logo" />

                <ul>
                    <li className={location.pathname === '/' ? 'side-link active' : 'side-link'}> <Link to='/' > <i className='fa fa-tachometer'></i>Dashboard </Link></li>
                    {/* {designation == "A" || designation == "B" ? <li className={location.pathname === '/leads' ? 'side-link active' : 'side-link'}> <Link to='/leads'> <i className='fa fa-users'></i>Leads </Link></li>
                        : <></>} */}


                    {designation == "A" || designation == "C" ? <li className={location.pathname === '/new-leads' ? 'side-link active' : 'side-link'}> <Link to='/new-leads'> <i className='fa fa-list'></i>New Leads </Link></li>
                        : <></>}

                    {designation == "D" || designation == "D" || designation == "F" ? <li className={location.pathname === '/new-followups' ? 'side-link active' : 'side-link'}> <Link to='/new-followups'> <i className='fa fa-phone'></i>New Follow Ups </Link></li>
                        : <></>}
                    {designation == "D" || designation == "D" || designation == "F" ? <li className={location.pathname === '/my-followups' ? 'side-link active' : 'side-link'}> <Link to='/my-followups'> <i className='fa fa-list'></i>My Follow Ups </Link></li>
                        : <></>}
                    {/* {designation == "A" || designation == "D" || designation == "F" ? <li className={location.pathname === '/out-of-inventory' ? 'side-link active' : 'side-link'}> <Link to='/out-of-inventory'> <i className='fa fa-outdent'></i>Out Of Inventory </Link></li>
                        : <></>}  */}
                    {designation == "A" || designation == "D" || designation == "F" ? <li className={location.pathname === '/working-done' ? 'side-link active' : 'side-link'}> <Link to='/working-done'> <i className='fa fa-check-square-o'></i>Working Done </Link></li>
                        : <></>}
                    {designation == "D" || designation == "D" ? <li className={location.pathname === '/my-leads' ? 'side-link active' : 'side-link'}> <Link to='/my-leads'> <i className='fa fa-users'></i>My Leads </Link></li>
                        : <></>}
                    {designation == "D" || designation == "D" ? <li className={location.pathname === '/my-report' ? 'side-link active' : 'side-link'}> <Link to='/my-report'> <i className='fa fa-users'></i>My Report </Link></li>
                        : <></>}

                    {/* {/* 
                    {designation == "A" || designation == "E" || designation == "F" ? <li className={location.pathname === '/new-r2v' ? 'side-link active' : 'side-link'}> <Link to='/new-r2v'> <i className='fa fa-eye'></i>New R2V </Link></li>
                        : <></>} */}
                    {/* {designation == "A" || designation == "E" || designation == "F" ? <li className={location.pathname === '/pending-visits' ? 'side-link active' : 'side-link'}> <Link to='/pending-visits'> <i className='fa fa-circle-o-notch'></i>Pending Visits </Link></li>
                        : <></>}
                    {designation == "A" || designation == "E" || designation == "F" ? <li className={location.pathname === '/visits-done' ? 'side-link active' : 'side-link'}> <Link to='/visits-done'> <i className='fa fa-check'></i>Visits Done </Link></li>
                        : <></>} */}
                    {/* {designation == "A" || designation == "F" ? <li className={location.pathname === '/my-all-leads' ? 'side-link active' : 'side-link'}> <Link to='/my-all-leads'> <i className='fa fa-users'></i>My All Leads </Link></li>
                        : <></>} */}
                    {/* {designation == "A" || designation == "E" ? <li className={location.pathname === '/my-visits' ? 'side-link active' : 'side-link'}> <Link to='/my-visits'> <i className='fa fa-users'></i>My Visits </Link></li>
                        : <></>} */}


                    {designation == "A" || designation == "B" ? <li className='side-link'> <button onClick={() => setToggleLeadPopup(1)}> <i className='fa fa-user-plus'></i> Add Lead </button></li>
                        : <></>}

                    {/* {designation == "A" ? <li className={location.pathname === '/pending-follow-ups' ? 'side-link active' : 'side-link'}> <Link to='/pending-follow-ups'> <i className='fa fa-users'></i>Pend. Follow Ups </Link></li>
                        : <></>}  */}

                    {/* {designation == "A" || designation == "C" ? <li className={location.pathname === '/new-visits' ? 'side-link active' : 'side-link'}> <Link to='/new-visits'> <i className='fa fa-eye'></i>New Visits </Link></li>
                        : <></>} */}
                    {/* {designation == "A" || designation == "C" ? <li className={location.pathname === '/all-follow-ups' ? 'side-link active' : 'side-link'}> <Link to='/all-follow-ups'> <i className='fa fa-users'></i>All Follow Ups </Link></li>
                        : <></>}

                    {designation == "A" ? <li className={location.pathname === '/digital-marketers' ? 'side-link active' : 'side-link'}> <Link to='/'> <i className='fa fa-user'></i>Digital Marketers </Link></li>
                        : <></>}
                    {designation == "A" ? <li className={location.pathname === '/telecallers' ? 'side-link active' : 'side-link'}> <Link to='/'> <i className='fa fa-headphones'></i>Telecallers </Link></li>
                        : <></>}
                    {designation == "A" ? <li className={location.pathname === '/Leads Managers' ? 'side-link active' : 'side-link'}> <Link to='/'> <i className='fa fa-black-tie'></i>Leads Managers </Link></li>
                        : <></>}
                    {designation == "A" ? <li className={location.pathname === '/Sales Team' ? 'side-link active' : 'side-link'}> <Link to='/'> <i className='fa fa-tag'></i>Sales Team </Link></li>
                        : <></>}
                    {designation == "A" ? <li className={location.pathname === '/settings' ? 'side-link active' : 'side-link'}> <Link to='/'> <i className='fa fa-gear'></i> Settings </Link></li>
                        : <></>} */}


                    {designation == "A" || designation == "B" || designation == "C" || designation == "D" ? <li className={location.pathname === '/leads-added-by-me' ? 'side-link active' : 'side-link'}> <Link to='/leads-added-by-me'> <i className='fa fa-users'></i>Added By Me </Link></li>
                        : <></>}
                    {designation == "C" || designation == "C" || designation == "C"? <li className={location.pathname === '/attendance-list' ? 'side-link active' : 'side-link'}> <Link to='/attendance-list'> <i className='fa fa-users'></i>Attendance List </Link></li>
                        : <></>}

                    {designation == "A" || designation == "A" ? <li className={location.pathname === '/admin-report' ? 'side-link active' : 'side-link'}> <Link to='/admin-report'> <i className='fa fa-users'></i>Reports </Link></li>
                        : <></>}

                    <li className='side-link'> <button onClick={() => logout()}> <i className='fa fa-power-off'></i>Log Out </button></li>
                </ul>
            </div>
        </>
    );
}

export default Header;